import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import TickSVG from '../assets/svg/tick.svg';

function ButtonSelect({ isActive, title, subtitle, className, tick= true, ...rest }) {
  const { section } = useSelector((state) => state.sectionSlice);
  return (
    <button
      type='button'
      className={classNames(
        'flex flex-col h-[110px] justify-center px-4 rounded-md duration-300',

        { 'bg-secondary-2': isActive && section && section.name === 'payroll' },
        { 'bg-hr-primary-1': isActive && section.name === 'core hr' },
        {
          'bg-spend-primary-1': isActive && section.name === 'spend management',
        },
        {
          ' border border-secondary-2-extralight': !isActive,
        },
        className
      )}
      {...rest}
    >
      <div className='flex flex-row w-full'>
        <div className='flex flex-col text-start w-5/6'>
          <span
            className={classNames('text-[15px] font-semibold', {
              'text-color-white': isActive,
            })}
          >
            {title}
          </span>
          <span
            className={classNames('p4-regular', {
              'text-color-white': isActive,
            })}
          >
            {subtitle}
          </span>
        </div>
        {tick && (
          <div
            className={classNames(
              'w-1/6 flex flex-row justify-end items-center md:mr-3',
              {
                hidden: !isActive,
              }
            )}
          >
            <img src={TickSVG} alt='' width={'30px'} />
          </div>
        )}
      </div>
    </button>
  )
}

export default ButtonSelect;
